import { apiPath } from '../../constants';
import { fetchCategoryOverview } from '../CategoryOverview';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const CORRECTION_START_REQUEST = 'POST_CORRECTION_START_REQUEST';
export const CORRECTION_START_SUCCESS = 'POST_CORRECTION_START_SUCCESS';
export const CORRECTION_START_FAILURE = 'POST_CORRECTION_START_FAILURE';

export const CORRECTION_RESET_RESULTS_REQUEST = 'POST_CORRECTION_RESET_RESULTS_REQUEST';
export const CORRECTION_RESET_RESULTS_SUCCESS = 'POST_CORRECTION_RESET_RESULTS_SUCCESS';
export const CORRECTION_RESET_RESULTS_FAILURE = 'POST_CORRECTION_RESET_RESULTS_FAILURE';

export const CORRECTION_REGENERATE_OFFICIAL_RESULTS_REQUEST = 'POST_CORRECTION_REGENERATE_OFFICIAL_RESULTS_REQUEST';
export const CORRECTION_REGENERATE_OFFICIAL_RESULTS_SUCCESS = 'POST_CORRECTION_REGENERATE_OFFICIAL_RESULTS_SUCCESS';
export const CORRECTION_REGENERATE_OFFICIAL_RESULTS_FAILURE = 'POST_CORRECTION_REGENERATE_OFFICIAL_RESULTS_FAILURE';

export const CORRECTION_FINISH_REQUEST = 'POST_CORRECTION_FINISH_REQUEST';
export const CORRECTION_FINISH_SUCCESS = 'POST_CORRECTION_FINISH_SUCCESS';
export const CORRECTION_FINISH_FAILURE = 'POST_CORRECTION_FINISH_FAILURE';

/**
 * The Category Correction Workflow (api/docs/CORRECTION.md) — the ONLY way
 * an already-confirmed category may be touched again. Backend = single
 * source of truth for every guard; every action here just re-reads the
 * category overview on success rather than guessing what changed (same
 * pattern as confirmOfficialResults/scoreRoundActions), so the lifecycle
 * state, the correction session block and every read-only gate always
 * reflect exactly what the server just did.
 */
export const startCorrection = (competition, category, reason) => {
    return function(dispatch) {
        dispatch({ type: CORRECTION_START_REQUEST });
        return axios(apiRequestOptions(
            apiPath.CATEGORY_CORRECTION.START,
            { reason },
            { params: { competition, category } },
        ))
            .then(transformHttpResponse)
            .then(response => {
                dispatch({ type: CORRECTION_START_SUCCESS, competition, category });
                dispatch(fetchCategoryOverview(competition, category));
                return response.data;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: CORRECTION_START_FAILURE, error });
                dispatch(errorRequestHandler(error));
            });
    }
};

export const resetCorrectionResults = (competition, category) => {
    return function(dispatch) {
        dispatch({ type: CORRECTION_RESET_RESULTS_REQUEST });
        return axios(apiRequestOptions(
            apiPath.CATEGORY_CORRECTION.RESET_RESULTS,
            null,
            { params: { competition, category } },
        ))
            .then(transformHttpResponse)
            .then(response => {
                dispatch({ type: CORRECTION_RESET_RESULTS_SUCCESS, results: response.data, competition, category });
                dispatch(fetchCategoryOverview(competition, category));
                return response.data;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: CORRECTION_RESET_RESULTS_FAILURE, error });
                dispatch(errorRequestHandler(error));
            });
    }
};

export const regenerateOfficialResults = (competition, category) => {
    return function(dispatch) {
        dispatch({ type: CORRECTION_REGENERATE_OFFICIAL_RESULTS_REQUEST });
        return axios(apiRequestOptions(
            apiPath.CATEGORY_CORRECTION.REGENERATE_OFFICIAL_RESULTS,
            null,
            { params: { competition, category } },
        ))
            .then(transformHttpResponse)
            .then(response => {
                dispatch({ type: CORRECTION_REGENERATE_OFFICIAL_RESULTS_SUCCESS, competition, category });
                dispatch(fetchCategoryOverview(competition, category));
                return response.data;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: CORRECTION_REGENERATE_OFFICIAL_RESULTS_FAILURE, error });
                dispatch(errorRequestHandler(error));
            });
    }
};

export const finishCorrection = (competition, category) => {
    return function(dispatch) {
        dispatch({ type: CORRECTION_FINISH_REQUEST });
        return axios(apiRequestOptions(
            apiPath.CATEGORY_CORRECTION.FINISH,
            null,
            { params: { competition, category } },
        ))
            .then(transformHttpResponse)
            .then(response => {
                dispatch({ type: CORRECTION_FINISH_SUCCESS, competition, category });
                dispatch(fetchCategoryOverview(competition, category));
                return response.data;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: CORRECTION_FINISH_FAILURE, error });
                dispatch(errorRequestHandler(error));
            });
    }
};
